module.exports = __webpack_public_path__ + "static/architecture-2368cd31c364e3ff7ff7ef1e9bfb3d1f.svg";